import React from "react";
import { Redirect } from "react-router-dom";
import Joi from "joi-browser";
import Form from "../common/form/form";
import auth from "./authService";
import logo from "../../assets/coke-logo.png";
import { Card, CardBody, CardGroup, Col, Container, Row } from "reactstrap";
import { CommonContext } from "../../context/CommonContext";

class LoginForm extends Form {
  static contextType = CommonContext;
  state = {
    data: { name: "", password: "" },
    errors: {},
    loading: false
  };

  schema = {
    name: Joi.string()
      .required()
      .error(() => {
        return { message: this.context.languageData.nameIsRequired };
      }),
    password: Joi.string()
      .required()
      .error(() => {
        return { message: this.context.languageData.passwordIsRequired };
      }),
  };

  doSubmit = async () => {
    const { languageData } = this.context;
    this.setState({ loading: true });
    try {
      const { data } = this.state;
      await auth.login(data.name, data.password);
      const { state } = this.props.location;
      const location = state ? state.from.pathname : "/";
      this.props.history.push(location);
      this.setState({ loading: false });
    } catch (ex) {
      if (ex.response && ex.response.status === 400) {
        const errors = { ...this.state.errors };
        console.log(languageData[ex.response.data["error_description"]]);
        errors.all = languageData[ex.response.data["error_description"]];
        this.setState({ errors, loading: false });
      }
    }
  };

  render() {
    const { errors, loading } = this.state;
    const { languageData } = this.context;
    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="5">
              <CardGroup>
                <Card className="p-3">
                  <CardBody>
                    <div className="text-center mb-3">
                      <img style={{ width: "100px" }} src={logo} alt="" />
                    </div>
                    {/* <h1>Login</h1> */}
                    <p className="text-muted">
                      {languageData.signInToYourAccount}
                    </p>
                    {errors.all && (
                      <div className="alert alert-danger">{errors.all}</div>
                    )}
                    <form onSubmit={this.handleSubmit}>
                      {this.renderIconInput(
                        "name",
                        languageData.userName,
                        "icon-user"
                      )}
                      {this.renderIconInput(
                        "password",
                        languageData.password,
                        "icon-lock",
                        "password"
                      )}
                      {this.renderButton(languageData.signIn, "Login", loading)}
                    </form>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default LoginForm;
